(function () {
  'use strict';
  if (window.__cgiInit) return;
  window.__cgiInit = true;

  var ATTR = 'Gift invoice';

  function save(on, card) {
    var body = { attributes: {} };
    body.attributes[ATTR] = on ? 'true' : '';

    if (card) card.classList.add('is--busy');

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .catch(function () {})
      .then(function () {
        if (card) card.classList.remove('is--busy');
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cgi-input]');
    if (!input) return;
    document.querySelectorAll('[data-cgi-input]').forEach(function (el) {
      if (el !== input) el.checked = input.checked;
    });
    save(input.checked, input.closest('[data-cgi]'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cgi-toggle]');
    if (!btn) return;
    e.preventDefault();

    var card = btn.closest('[data-cgi]');
    var desc = card ? card.querySelector('[data-cgi-desc]') : null;
    if (!desc) return;

    var open = desc.hidden;
    desc.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function sync() {
    var inputs = document.querySelectorAll('[data-cgi-input]');
    if (!inputs.length) return;
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var on = !!(cart.attributes && cart.attributes[ATTR] === 'true');
        inputs.forEach(function (el) { if (el.checked !== on) el.checked = on; });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('cart:section-refreshed', sync);
  document.addEventListener('cart:refresh', sync);
})();
